import {useEffect} from 'react';

import {isS3URLExpired} from 'external-files/SignedExtFileURLProxy';

/**
 * Signed S3 URLs expire (~1h). Handing an expired URL to the Mol* viewer renders a broken canvas, so
 * refetch the owning resource to mint a fresh URL instead. Returns whether the URL is currently
 * expired so callers can render a loader until the refetched URL arrives.
 */
export function useRefreshOnExpiredUrl(url: string, onRefresh: () => void): boolean {
  const expired = isS3URLExpired(url);
  useEffect(() => {
    if (expired) {
      onRefresh();
    }
  }, [expired, onRefresh]);
  return expired;
}
